var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styles from "../HandFilter.module.scss";
import PlayerComponent from "./PlayerComponent";
import { HeroVillainSwitcher } from "./HeroVillainSwitcher";
import { allowedAllButton } from "../../constants";
import { useComponentLocale } from "../../../hooks/useComponentLocale";
import { Button } from "antd";
var Player = function (_a) {
    var collapsed = _a.collapsed, filter = _a.filter, onFilterApply = _a.onFilterApply, librariesResponse = _a.librariesResponse, modifyPlayerFilter = _a.modifyPlayerFilter, disabled = _a.disabled, selectedTab = _a.selectedTab;
    var getLocale = useComponentLocale();
    var player = getLocale({ component: 'hands', section: 'player' });
    var manageAliasesLocale = getLocale({ component: 'common_buttons', section: 'manage_aliases' });
    var isShow = function (part) {
        switch (part) {
            case 'heroSwitcher': {
                var allowedTab = ['handLine', 'report', 'handLineStats', 'handLineStatsForPlayers', 'handMistakeStats'];
                return filter.source !== 'trainer' && allowedTab.includes(selectedTab);
            }
            case 'against': {
                var allowedTab = ['hands', 'handLine', 'report', 'handLineStats', 'replayer'];
                if (selectedTab === 'hands' || selectedTab === 'replayer') {
                    return filter.source !== 'trainer' && allowedTab.includes(selectedTab);
                }
                return filter.source !== 'trainer' && allowedTab.includes(selectedTab) && filter.is_hero;
            }
            case 'manageAliases': {
                return filter.source === 'upload';
            }
        }
    };
    var isHero = useMemo(function () {
        var trueTabs = ['hands', 'replayer'];
        if (trueTabs.includes(selectedTab) || filter.source === 'trainer') {
            return true;
        }
        if (allowedAllButton.includes(selectedTab)) {
            return filter.hero;
        }
        return filter.is_hero;
    }, [selectedTab, filter.source, filter.is_hero, filter.hero]);
    return (_jsxs("div", __assign({ className: !collapsed ? styles.filterBlock : styles.filterBlockCollapsed }, { children: [collapsed && (_jsx("div", __assign({ className: styles.optionalTitle }, { children: player }))), isShow('heroSwitcher') && (_jsx(HeroVillainSwitcher, { filter: filter, onFilterApply: onFilterApply, selectedTab: selectedTab })), _jsx(PlayerComponent, { filter: filter, modifyPlayerFilter: modifyPlayerFilter, onFilterApply: onFilterApply, librariesResponse: librariesResponse, isHero: isHero, disabled: disabled, selectedTab: selectedTab, isAgainstVillain: false }), isShow('against') && (_jsx(PlayerComponent, { filter: filter, modifyPlayerFilter: modifyPlayerFilter, onFilterApply: onFilterApply, librariesResponse: librariesResponse, isHero: false, disabled: disabled, selectedTab: selectedTab, isAgainstVillain: true })), isShow('manageAliases') && (_jsx(Button, __assign({ href: '/settings/aliases', target: '_blank', rel: 'noreferrer', size: 'small', type: 'text', className: [styles.manageButton, collapsed ? styles.manageButtonCollapsed : ''].join(' ') }, { children: manageAliasesLocale })))] })));
};
export default Player;
